import React from 'react'
import { SanityBannerBlock } from '../../../../../types/generated/graphql-types'
import { sanityBannerToBannerProps } from '../../../../mapping/BannerMapper'
import { BlockWithId } from '../../../../utilities/blockId'
import { Banner } from '../../../blocks/Banner'
import { Section } from '../../../Section'

export const BannerSerializer = ({
  id,
  ...props
}: SanityBannerBlock & BlockWithId): JSX.Element => (
  <Section id={id}>
    <Banner {...sanityBannerToBannerProps(props)} />
  </Section>
)
